import React, { useState, useEffect } from "react";
import {
  BsFillArchiveFill,
  BsFillGrid3X3GapFill,
  BsPeopleFill,
  BsFillBellFill,
} from "react-icons/bs";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";
import { image } from "../../src/common/Theme";
import { toast, ToastContainer } from "react-toastify";
import Apiconnection from "../utils/Apiconnection";
import { FaTrash } from "react-icons/fa"; // Importing the trash icon
import { BorderColor } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import moment from "moment";

function Home() {
  const [DashboardCount, setDashboardCount] = useState([]);
  const [latestBookings, setLatestBookings] = useState([]);
  const [chartData, setChartData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getDashboardCountApi();
    getLatestBookingsApi();
    getChartDataApi();
    // getNotificationApi();
  }, []);

  const getDashboardCountApi = async () => {
    const payload = {
      parkingGroundId: "1",
    };
    // settableloading(true);
    try {
      const response = await Apiconnection.post("slot-analytics", payload);
      console.log("slot-analytics", response);
      if (response?.data?.status) {
        setDashboardCount(response.data.data);
      } else {
        // toast.error(response?.message);
      }
    } catch (error) {
      console.error("Error fetching Agent list:", error);
      // toast.error('Failed to fetch Agent list.');
    } finally {
      // settableloading(false);
    }
  };

  const getLatestBookingsApi = async () => {
    try {
      const response = await Apiconnection.post(
        "booking-request-list?page=1&limit=4",
      );
      if (response?.data?.status) {
        setLatestBookings(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching latest bookings:", error);
    }
  };

  const getChartDataApi = async () => {
    try {
      const response = await Apiconnection.post(
        "booking-request-list?page=1&limit=100",
      );
      if (response?.data?.status) {
        const bookings = response.data.data;
        const groups = {};

        // Populate the last 7 days dynamically
        for (let i = 6; i >= 0; i--) {
          const dateStr = moment().subtract(i, "days").format("DD MMM");
          groups[dateStr] = { booked: 0, checkedIn: 0 };
        }

        bookings.forEach((booking) => {
          if (booking.fromDate) {
            const dateStr = moment(booking.fromDate).format("DD MMM");
            if (groups[dateStr]) {
              groups[dateStr].booked += 1;
              if (
                booking.bookingStatus === "Checked In" ||
                booking.bookingStatus === "Checked Out"
              ) {
                groups[dateStr].checkedIn += 1;
              }
            }
          }
        });

        const formattedData = Object.keys(groups).map((date) => ({
          name: date,
          "Booked Slots": groups[date].booked,
          "Checked In": groups[date].checkedIn,
        }));

        setChartData(formattedData);
      }
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  };

  const getInitials = (booking) => {
    const first = booking?.user?.firstName?.charAt(0)?.toUpperCase() || "";
    const last = booking?.user?.lastName?.charAt(0)?.toUpperCase() || "";
    return first + last || "BK";
  };

  const getBookingTime = (booking) => {
    if (booking?.createdAt) {
      return moment(booking.createdAt).fromNow(true);
    }
    if (booking?.fromDate) {
      return moment(booking.fromDate).format("DD MMM");
    }
    return "";
  };

  const getNotificationApi = async () => {
    try {
      const response = await Apiconnection.post("notification-list");
      if (response?.data?.status) {
        const notifications = response.data.data.notifications;
        // Filter out notifications that are already read
        const unreadNotifications = notifications.filter(
          (notification) => !notification.isRead,
        );
        unreadNotifications.forEach((notification) => {
          displayNotification(notification);
        });
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const displayNotification = (notification) => {
    const toastId = toast.info(
      <div>
        <div>
          <strong>{notification.notiTitle}</strong>
          <p>{notification.notiBody}</p>
        </div>
        <button
          className="save-btn"
          onClick={() => handleMarkAsRead(notification.id)}
        >
          Mark as Read
        </button>
        <button
          className="save-btn mr-2"
          style={{
            lineHeight: "20px",
            padding: "10px 15px !important",
            marginLeft: "2px",
            backgroundColor: "unset !important",
            border: "unset !important",
          }}
          onClick={() => handleDeleteNotification(notification.id)}
        >
          <FaTrash style={{ color: "red", fontSize: "1.5em" }} />
        </button>
      </div>,
      {
        autoClose: false, // Prevent auto close
        closeButton: false, // Disable default close button
      },
    );
  };

  const handleDeleteNotification = async (notificationId) => {
    try {
      const payload = { notificationId };
      await Apiconnection.post("notification-delete", payload);
      toast.dismiss(); // Dismiss the toast after deletion
    } catch (error) {
      console.error("Error deleting notification:", error);
      toast.error("Failed to delete notification.");
    }
  };

  const handleMarkAsRead = async (notificationId) => {
    try {
      const payload = { notificationId, isRead: true };
      await Apiconnection.post("notification-status-change", payload);
      toast.success("Notification marked as read.");
    } catch (error) {
      console.error("Error marking notification as read:", error);
      toast.error("Failed to mark notification as read.");
    }
  };

  return (
    <main className="main-container">
      <div className="row">
        <div className="col-lg-8">
          <div className="main-cards">
            <div className="card-inner">
              <div className="card-left">
                <h6>Total Slots</h6>
                <h3>{DashboardCount.totalSlots}</h3>
                <p style={{ color: "white" }}>.</p>
              </div>
              <div className="card-right">
                <img src={image.chartimg1} alt="" />
              </div>
            </div>

            <div className="card-inner">
              <div className="card-left">
                <h6>Booked Slots</h6>
                <h3>{DashboardCount.totalBookedSlots}</h3>
                <p>{DashboardCount.totalOverstaySlots} overstay</p>
              </div>
              <div className="card-right">
                <img src={image.chartimg2} alt="" />
              </div>
            </div>
            <div className="card-inner">
              <div className="card-left">
                <h6>Free Slots</h6>
                <h3>{DashboardCount.totalFreeSlots}</h3>
                <p style={{ color: "white" }}>.</p>
              </div>
              <div className="card-right">
                <img src={image.chartimg3} alt="" />
              </div>
            </div>
          </div>
          <div className="charts">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={chartData}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis allowDecimals={false} />
                <Tooltip />
                <Legend />
                <Bar dataKey="Booked Slots" fill="#F7931E" />
                <Bar dataKey="Checked In" fill="#13D3A9" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="payment-info">
            <img src={image.payments} alt="" />
            <div className="payment-status">
              <p>Payment Received</p>
              <h5>$ 357699</h5>
            </div>
          </div>
          <div className="booking-sec">
            <div className="booking-header">
              <h4>New Bookings</h4>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/bookings");
                }}
              >
                VIEW ALL
              </a>
            </div>
            {latestBookings && latestBookings.length > 0 ? (
              latestBookings.map((booking) => (
                <div className="booking-box" key={booking.id}>
                  <div className="booking-user">
                    <h4>{getInitials(booking)}</h4>
                  </div>
                  <div className="booking-details">
                    <h5>
                      {booking?.user?.firstName || ""}{" "}
                      {booking?.user?.lastName || ""}
                    </h5>
                    <p>
                      Ticket: {booking?.bookingTicketNo || "N/A"} | Slot:{" "}
                      {booking?.slot?.slotName || "N/A"}
                    </p>
                    <div className="booking-time">
                      <p>{getBookingTime(booking)}</p>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/bookings");
                        }}
                      >
                        <img src={image.action} alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div
                className="booking-box justify-content-center align-items-center"
                style={{ padding: "20px" }}
              >
                <p style={{ margin: 0, color: "#aaa" }}>
                  No new bookings found.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* <ToastContainer
        style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: '9999',
          maxHeight: '300px',
          overflowY: 'auto',
        }}
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        pauseOnFocusLoss
      /> */}
    </main>
  );
}

export default Home;
